import { AnalyticsApi, AnalyticsEvent } from '@backstage/core-plugin-api';

const BATCH_INTERVAL_MS = 5_000;
const MAX_BATCH_SIZE = 50;

/**
 * Analytics provider that batches events and POSTs them to the Backstage
 * backend, where they are exposed as Prometheus counters.
 */
export class PrometheusAnalytics implements AnalyticsApi {
  private buffer: AnalyticsEvent[] = [];
  private timer: ReturnType<typeof setInterval> | null = null;
  private readonly endpoint: string;

  constructor(endpoint: string) {
    this.endpoint = endpoint;
  }

  captureEvent(event: AnalyticsEvent): void {
    this.buffer.push(event);

    if (this.buffer.length >= MAX_BATCH_SIZE) {
      this.flush();
    }

    if (!this.timer) {
      this.timer = setInterval(() => this.flush(), BATCH_INTERVAL_MS);
    }
  }

  private async flush(): Promise<void> {
    if (this.buffer.length === 0) return;

    const events = this.buffer.splice(0);
    try {
      await fetch(this.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ events }),
      });
    } catch {
      // Silently drop — analytics should never break the app
    }
  }
}
